/**
 * Add user info to profile info block when user is logged in
 */
document.addEventListener('zooza_user_logged_in', function (event) {
  console.log('User logged in:', event.detail);

  updateProfileInfo(
    event.detail?.first_name,
    event.detail?.last_name,
    event.detail?.avatar,
  );
});

document.addEventListener('DOMContentLoaded', function () {
  // Get data from local storage
  const zooza_user = localStorage.getItem('zooza_user');

  if (zooza_user) {
    const user = JSON.parse(zooza_user);
    updateProfileInfo(user?.first_name, user?.last_name, user?.avatar);
  }
});

const updateProfileInfo = (
  first_name: string,
  last_name: string,
  avatar: string,
) => {
  const avatarEl = document.querySelector('.js-profile-avatar');
  const nameEl = document.querySelector('.js-profile-name');
  const profileInfoEl = document.querySelector('.js-profile-info');

  const fullName = `${first_name} ${last_name}`;

  console.log(fullName);

  if (avatarEl) {
    avatarEl.style.backgroundImage = `url(${avatar})`;
  }

  nameEl.innerHTML = fullName;
  profileInfoEl.style.display = 'block';
};

/**
 * Remove user info from profile info block when user is logged out
 */
document.addEventListener('zooza_user_logged_out', function (event) {
  console.log('User logged out:', event.detail);

  const profileInfoEl = document.querySelector(
    '.js-profile-info',
  ) as HTMLElement;
  const avatarEl = document.querySelector('.js-profile-avatar') as HTMLElement;
  const nameEl = document.querySelector('.js-profile-name') as HTMLElement;

  if (profileInfoEl) {
    profileInfoEl.style.display = 'none';
  }

  if (avatarEl) {
    avatarEl.style.backgroundImage = 'none';
  }

  if (nameEl) {
    nameEl.innerHTML = '';
  }

  // refresh page (guarded against infinite reload loops)
  reloadAfterLogout();
});

/**
 * Reload the page after logout while preventing the infinite-reload loop.
 *
 * A single-use Zooza magic-login `token` left in the URL makes the widget
 * fail login and re-fire `zooza_user_logged_out` on every load. Reloading
 * unconditionally then loops forever (looks like the URL redirecting to
 * itself). We defend on two fronts:
 *   1. Strip the dead `token` param so the failed login isn't retried.
 *   2. Throttle reloads so even a token-less logout can't loop.
 */
const RELOAD_GUARD_KEY = 'bb_logout_reload_ts';
const RELOAD_GUARD_WINDOW = 10000; // ms

const reloadAfterLogout = () => {
  const url = new URL(window.location.href);
  const hadToken = url.searchParams.has('token');

  // Remove the single-use login param so a reload can't re-trigger the
  // already-failed login (this is what causes the loop).
  url.searchParams.delete('token');

  if (hadToken) {
    // Cleaning the token is itself a navigation and removes the loop cause.
    // Use replace() so the dead-token URL doesn't pollute history.
    window.location.replace(url.toString());
    return;
  }

  // No token to strip: reload, but not again within the guard window.
  const last = Number(sessionStorage.getItem(RELOAD_GUARD_KEY) || 0);
  const now = Date.now();
  if (now - last < RELOAD_GUARD_WINDOW) {
    return;
  }
  sessionStorage.setItem(RELOAD_GUARD_KEY, String(now));
  window.location.reload();
};

/**
 * Custom logout button
 */
const forceLogoutEvent = new CustomEvent('zooza_user_force_logout', {
  // details: {
  //   redirect_url: 'https://google.com',
  // },
});

// Add event listener to the logout button
const logoutButton = document.querySelector('.js-profile-logout');
if (logoutButton) {
  logoutButton.addEventListener('click', function () {
    document.dispatchEvent(forceLogoutEvent);
  });
}
